export function createRecord<T extends string, V>(
  fields: Record<string, T>,
  value: V,
): Record<T, V> {
  return Object.fromEntries(Object.values(fields).map((field) => [field, value])) as Record<T, V>;
}

export function isPlainObject(value: any): boolean {
  return Object.prototype.toString.call(value) === '[object Object]';
}

export function cloneObject<T>(object: T): T {
  return JSON.parse(JSON.stringify(object));
}
